export const lookupFilterType = 'Lookup';